module.exports = __webpack_public_path__ + "img/premb-r-pm-mobile-2.a138736e.svg";